import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { SyncTargetDepartmentsGetResponse } from "@/types/swagger";
import API from "@/api";

export interface IDepartmentsState {
  sync_target_departments: ICompanyDepartment[];
}

export interface ICompanyDepartment {
  tt_company_id: number; // 会社ID（TimeTappsから同期された情報）
  company_name: string; // 会社名
  departments?: IDepartment[]; // 所属一覧
}

export interface IDepartment {
  department_id: number; // 所属ID
  sync_target_group_id: number; // 同期対象グループID
  tt_department_id: number; // 所属ID（TimeTappsから同期された情報）
  tt_department_name: string; // 所属名（TimeTappsから同期された情報）
  tt_disp_sort: number; // 表示順
}

const initialState: IDepartmentsState = {
  sync_target_departments: [],
};

@Module({
  name: "Departments",
  stateFactory: true,
  namespaced: true,
})
export class Departments extends VuexModule {
  private departments: IDepartmentsState = initialState;

  public get getDepartments() {
    return this.departments;
  }

  @Mutation set(departments: IDepartmentsState) {
    this.departments = departments;
  }

  @Action({ rawError: true })
  public init() {
    this.set(initialState);
  }

  @Action({ rawError: true })
  public async fetchDepartments(userId: number) {
    const api = new API();
    const response: SyncTargetDepartmentsGetResponse = await api.get(
      `/users/${userId}/sync/departments`,
      {}
    );
    if (Array.isArray(response.sync_target_departments)) {
      const companyDepartments: ICompanyDepartment[] = [];
      response.sync_target_departments.forEach((cdep: any) => {
        if (cdep.tt_company_id && cdep.company_name) {
          const companyDepartment: ICompanyDepartment = {
            tt_company_id: cdep.tt_company_id,
            company_name: cdep.company_name,
            departments: [],
          };
          if (Array.isArray(cdep.departments)) {
            cdep.departments.forEach((departments: any) => {
              if (
                departments.department_id &&
                departments.sync_target_group_id &&
                departments.tt_department_id &&
                departments.tt_department_name &&
                departments.tt_disp_sort
              ) {
                const dep: IDepartment = {
                  department_id: departments.department_id,
                  sync_target_group_id: departments.sync_target_group_id,
                  tt_department_id: departments.tt_department_id,
                  tt_department_name: departments.tt_department_name,
                  tt_disp_sort: departments.tt_disp_sort,
                };
                if (Array.isArray(companyDepartment.departments))
                  companyDepartment.departments.push(dep);
              }
            });
          }
          companyDepartments.push(companyDepartment);
        }
      });
      this.set({ sync_target_departments: companyDepartments });
    }
  }
}
